import { createContext, useEffect, useState } from 'react';
import { GlobalContextType } from '../types/GlobalContextType';
import useGetGeneralSettings from '../modules/settings/general/hooks/useGetGeneralSettings';

const GlobalContext = createContext<Partial<GlobalContextType>>({});

// @ts-ignore
export const GlobalDataProvider = ({ children }) => {
	const {
		companyName,
		companyAddress,
		companyLogo,
		companyTheme,
		activeCompany,
		privacyPolicyEn,
		privacyPolicyAr,
		termsServiceEn,
		termsServiceAr,
		afterRegisterPageSectionEn,
		afterRegisterPageSectionAr,
		contactEmail,
		contactPhoneNumber,
		dashboardTitle,
		dashboardSubTitle,
		dashboardImage,
		registerWelcomeAr,
		registerWelcomeEn,
		qrScanGuidelinesEn,
		qrScanGuidelinesAr
	} = useGetGeneralSettings();

	useEffect(() => {
		// Update the favicon
		const favicon = document.querySelector('link[rel="icon"]') as any;
		if (favicon) {
			favicon.href = companyLogo?.value ?? '/sorgex-logo.png';
		}
		const faviconApple = document.querySelector('link[rel="apple-touch-icon"]') as any;
		if (faviconApple) {
			faviconApple.href = companyLogo?.value ?? '/sorgex-logo.png';
		}
	}, [companyLogo]);

	return (
		<GlobalContext.Provider
			value={{
				companyName,
				companyAddress,
				companyLogo,
				companyTheme,
				activeCompany,
				privacyPolicyEn,
				privacyPolicyAr,
				termsServiceEn,
				termsServiceAr,
				afterRegisterPageSectionEn,
				afterRegisterPageSectionAr,
				contactEmail,
				contactPhoneNumber,
				dashboardTitle,
				dashboardSubTitle,
				dashboardImage,
				registerWelcomeAr,
				registerWelcomeEn,
				qrScanGuidelinesEn,
				qrScanGuidelinesAr
			}}
		>
			{children}
		</GlobalContext.Provider>
	);
};

export default GlobalContext;
